import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import { Box, Container, Snackbar } from '@mui/material';
import dayjs from 'dayjs';

import { addUpdateMember } from 'src/api/member';
import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';
import MemberForm from 'src/components/member/MemberForm';
import { loaderReducerAction } from 'src/redux/reducers/loader';

const AddMember = () => {
  const { startLoading, stopLoading } = loaderReducerAction;
  const dispatch = useDispatch();
  const { user ,gymId } = useSelector((state) => state.common);
  const { batchList } = useSelector((state) => state.batches);
  const { membershipPlanList } = useSelector((state) => state.membershipPlan);
  const { trainerList } = useSelector((state) => state.trainer);
  const [number, setNumber] = useState('');
  const [countryCode, setCountryCode] = useState('us');
  const [valid, setValid] = useState(true);
  const { dietPlanList } = useSelector((state) => state.dietPlan);

  const HandleChange = (value ,code) => {
    setNumber(value);
    setCountryCode(code);
    setValid(validatePhoneNumber(value));
  };
  const validatePhoneNumber = (number) => {
    const numberPattern = /^\d{10}/;
    return numberPattern.test(number);
  };

  const showerror = (value) => {
    setValid(validatePhoneNumber(value));
  };

  const navigate = useNavigate();

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });

  const getMemberShipPlanId = (name) => {
    const value = membershipPlanList.filter((plan) => plan?.name === name);
    return value[0]._id;
  };
  const getTrainerId = (name) => {
    const value = trainerList.filter((trainer) => trainer?.name === name);
    return value[0]._id;
  };
  const getBatchId = (name) => {
    const value = batchList.filter((batch) => batch?.name === name);
    return value[0]._id;
  };
  const getDietPlanId = (name) => {
    const value = dietPlanList.filter((dietPlan) => dietPlan?.name === name);
    return value[0]._id;
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Helmet>
        <title>Members | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '2rem'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              name: '',
              fatherName: '',
              email: '',
              address: '',
              mobileNumber: '',
              dateOfBirth: '',
              gender: 0,
              weight: '',
              height: '',
              membershipPlan: '',
              batch: '',
              dietplan:'',
              trainer: '',
              membershipStartDate: '',
              membershipEndDate: '',
              paymentReminderDay: '',
              remarks: '',
              profilePic: null
            }}
            validationSchema={CONSTANTS.memberValidationSchema}
            onSubmit={async (values) => {
              const membershipPlan = getMemberShipPlanId(values.membershipPlan);
              const batch = getBatchId(values.batch);
              const trainer = getTrainerId(values.trainer);
              const dietPlan = getDietPlanId(values.dietplan);
              try {
                const formData = new FormData();
                formData.append('full_name', values.name);
                formData.append('father_name', values.fatherName);
                formData.append('email', values.email);
                formData.append('address', values.address);
                formData.append('phone', number.slice(countryCode.length));
                formData.append('calling_code', "+"+countryCode);
                formData.append('dob', dayjs(values.dateOfBirth).toISOString());
                formData.append('gender', values.gender);
                formData.append('weight', values.weight);
                formData.append('height', values.height);
                formData.append('plan_id', membershipPlan);
                formData.append('diet_plan_id', dietPlan);
                formData.append('batch_id', batch);
                formData.append('trainer_id', trainer);
                formData.append(
                  'membership_start_date',
                  dayjs(values.membershipStartDate).format('DD-MM-YYYY')
                );
                formData.append(
                  'membership_end_date',
                  dayjs(values.membershipEndDate).format('DD-MM-YYYY')
                );
                formData.append(
                  'payment_reminder_day',
                  values.paymentReminderDay
                );
                formData.append('remarks', values.remarks);
                formData.append('gym_id', gymId);
                if (values.profilePic) {
                  formData.append('profile_pic', values.profilePic);
                }
                dispatch(startLoading());
                const res = await addUpdateMember(user, formData);
                dispatch(stopLoading());
                const isError = res.status !== 200;
                const message = isError ? res?.message : "Member Added Successfully"
                setSnackbarState({
                  open: true,
                  message: message,
                  severity: isError ? 'error' : 'success'
                });
                if (!isError) {
                  navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.MEMBERS);
                }
              } catch (err) {
                dispatch(stopLoading());
                setSnackbarState({
                  open: true,
                  message: err.message,
                  severity: 'error'
                });
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              touched,
              values
            }) => (
              <MemberForm
                number={number}
                countryCode={countryCode}
                HandleChange={HandleChange}
                errors={errors}
                handleBlur={handleBlur}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                touched={touched}
                values={values}
                heading={STRINGS.ADD_MEMBER}
                valid={valid}
                showerror={showerror}
              />
            )}
          </Formik>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarState.open}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <div>
              <Alert onClose={handleClose} severity={snackbarState.severity}>
                {snackbarState.message}
              </Alert>
            </div>
          </Snackbar>
        </Container>
      </Box>
    </>
  );
};

export default AddMember;
